import YouTubePlayer from 'youtube-player';

class VisualYoutube {
  constructor(el) {
    this.dom = {el: el};
    this.dom.player = this.dom.el.querySelector('[data-js="youtube"]');

    this.player = null;
    this.videoId = this.dom.player.dataset.videoid;

    this.isInit = false;
    this.isPlaying = false;

    this.check = this.check.bind(this);
    this.setSetting = this.setSetting.bind(this);

    this.device = null;
    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {
    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
    
    // this.dom.player.style.opacity = 0;
    this.player = YouTubePlayer('ytplayer', {
      videoId: this.videoId,
      width: '640',
      height: '360',
      playerVars: {
        controls: 0,
        disablekb: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
        loop: 1,
        playsinline: 1,
        playlist: this.videoId
      },
    });

    this.player.on('ready', e => {
      // this.player.playVideo();
      this.player.mute();
      
      // player is replaced by YT script. get the dom again.
      this.dom.player = this.dom.el.querySelector('#ytplayer');
      this.player.pauseVideo();

      this.play();
    });

    this.player.on('stateChange', e => {
      if (e.data === YT.PlayerState.ENDED) {
        this.player.mute();
      }
      if (e.data === YT.PlayerState.PLAYING) {
        if (!this.isInit) {
          this.isInit = true;
          this.isPlaying = true;
        }
      }
    });

    if (this.player) {
      this.check();
      window.addEventListener('resize', this.check);
      window.addEventListener('orientationchange', this.orientationchange);
    }
  }

  setSetting(w, h) {
    // if (this.device === 'pc') {
      if (w / h < 640 / 360) { // 1.7777777...
        this.dom.player.style.width = `${h * (640 / 360)}px`;
        // this.dom.player.style.height = `${h * 2}px`;
        this.dom.player.style.height = `${h}px`;
      } else {
        this.dom.player.style.width = `${w + 2}px`;
        this.dom.player.style.height = `${h * 2}px`;
      }
    // } else {
    //   if (w / h < 1080 / 1920) { // 1.7777777...
    //     this.dom.player.style.width = `${h * (1080 / 1920) + 2}px`;
    //     this.dom.player.style.height = `${h * 2}px`;
    //   } else {
    //     this.dom.player.style.width = `${w + 2}px`;
    //     this.dom.player.style.height = `${h * 2}px`;
    //   }
    // }
  }

  check() {
    const ww = window.outerWidth;
    const wh = window.outerHeight;

    this.setSetting(ww, wh);
    // backup state
    this.ww = ww;
  }

  orientationchange() {
    const self = this;
    const timeout = setTimeout(() => {
      self.check();
      clearTimeout(self.timeout);
      self.timeout = timeout;
    }, 500);
  }

  play() {
    if (!this.isPlaying) {
      this.player.playVideo();
      this.Playing = true;
    }
  }

  pause() {
    this.player.pauseVideo();
    this.isPlaying = false;
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      this.device = 'sp';
      return;
    } else {
      // console.log('pc');
      this.device = 'pc';
      return;
		}
	}
}

export default VisualYoutube